import request from "@/api/request";

//获取省份
export function getProvinceModel() {
  return request({
    url: `/app/province/getProvinceModel?state=${0}`,
  });
}

//获取城市
export function getCityModel(val) {
  return request({
    url: `/app/province/getCityModel?state=${0}&province_code=${val}`,
  });
}

//获取区域
export function getAreaModel(val) {
  return request({
    url: `/app/province/getAreaModel?state=${0}&city_code=${val}`,
  });
}

//获取卡种
export function getChangeCardSpecies(val) {
  return request({
    url: `/app/changeCardOrder/getChangeCardSpecies?logoutTypeId=${val}`,
  });
}

//换卡详情
export function getByOldCard() {
  return request({
    url: `/app/changeCardOrder/getByOldCard?oldCard=${localStorage.getItem(
      "meCardNum"
    )}`,
  });
}
